import React from 'react';
import hasPermission from '../../functions/access-control';

type AccessControlComponentProps = {
  children: React.ReactNode;
  permission: string | Array<string>;
};
const AccessControlComponent = ({
  children,
  permission,
}: AccessControlComponentProps) => {
  return <>{hasPermission(permission) ? children : null}</>;
};
export default AccessControlComponent;
